import $ from 'jquery';
import { publish, unpublish, subscribe } from 'Util/pubsub';
import { Universal } from 'App/track/analytics/universal';


var selectors = {};

var Utility = {
	init: function () {
		Utility = this;
	},

	publishEvent: function (data) {
		Universal.sendEvent(data);
	},

	publishPage: function (data) {
		Universal.sendPageView(data);
	}
};

export { Utility };